import DashboardGrid from '@/components/dashboard/dashboard-grid/dashboard-grid';
import { Box, Divider } from '@cmpsr/components';
import DashboardRiskHeader from './components/dashboard-risk-header/dashboard-risk-header';
import DashboardRisks from './components/dashboard-risks/dashboard-risks';
import useDashboardBodyController from './dashboard-body.controller';
import DashboardLayout from '@/components/dashboard/dashboard-layout/dashboard-layout';
export default function DashboardBody({ children }: { children: React.ReactNode }) {
  const { risks, cancersAbove, cancersBelow, cancersAverage, stepSize } = useDashboardBodyController();

  return (
    <DashboardLayout>
      <DashboardGrid>
        <Box as="main" w="100%">
          {risks && risks.length ? (
            <>
              <DashboardRiskHeader
                cancersAbove={cancersAbove}
                cancersBelow={cancersBelow}
                cancersAverage={cancersAverage}
              />
              <DashboardRisks risks={risks} stepSize={stepSize} />
            </>
          ) : null}
        </Box>
        <Divider display={{ base: 'block', lg: 'none' }} my="spacer-9" />
        <Box as="aside" minW="full">
          {children}
        </Box>
      </DashboardGrid>
    </DashboardLayout>
  );
}
